import { useState } from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import MESSAGES from 'core/data-model/constants/messages'

const ANSWER_CHOICE_KEYS = [
  { choice: 'FIRST', thKey: 'displayFirstChoiceTH', enKey: 'displayFirstChoiceEN' },
  { choice: 'SECOND', thKey: 'displaySecondChoiceTH', enKey: 'displaySecondChoiceEN' },
  { choice: 'THIRD', thKey: 'displayThirdChoiceTH', enKey: 'displayThirdChoiceEN' },
  { choice: 'FOURTH', thKey: 'displayFourthChoiceTH', enKey: 'displayFourthChoiceEN' },
]

const getChoicesFromQuestion = (question) => {
  return ANSWER_CHOICE_KEYS.filter(({ thKey }) => question[thKey] != null).map(({ choice, thKey, enKey }) => {
    const score = question.answerScores?.find((s) => s.answerChoice === choice)
    return {
      answerChoice: choice,
      textTH: question[thKey],
      textEN: question[enKey],
      score: score?.score ?? 0,
    }
  })
}

const Suitability = ({ suitabilityQuestion, updateSuitabilityAnswer, answers }) => {
  const [localAnswers, setLocalAnswers] = useState([])

  const currentAnswers = answers && Array.isArray(answers) ? answers : localAnswers

  const getAnswerForQuestion = (questionCode) => currentAnswers.find((a) => a.questionCode === questionCode)

  const handleSelectAnswer = (questionCode, answerMode, answerChoice, optionalCode) => {
    if (updateSuitabilityAnswer) {
      updateSuitabilityAnswer({ questionCode, answerMode, answerChoice, optionalCode })
    } else {
      setLocalAnswers((prev) => {
        const existing = prev.filter((a) => a.questionCode !== questionCode)
        return [...existing, { questionCode, answerMode, answerChoice, optionalCode }]
      })
    }
  }

  const sortedQuestions = [...(suitabilityQuestion || [])].sort((a, b) => a.orderSequence - b.orderSequence)

  return (
    <div>
      <p className="title">{MESSAGES.SUITABILITY_QUESTION_TITLE}</p>
      <div id="list-questionnaire">
        {sortedQuestions.map((question, i) => {
          const choices = getChoicesFromQuestion(question)
          return (
            <div key={i}>
              <li className="question-item form-group" key={question.questionCode} style={{ paddingLeft: '15px' }}>
                <span className="question-text">
                  <span>{question.questionNameTH}</span>
                  <span className="sub" style={{ fontWeight: 'normal', marginLeft: '20px' }}>
                    {question.subquestionNameTH}
                  </span>
                </span>
                {question.questionImage && (
                  <div className="question-image">
                    <img src={question.questionImage} alt={`question-${question.questionCode}`} />
                  </div>
                )}
                <ListGroup style={{ marginLeft: '20px' }}>
                  {choices.map((choice, index) => (
                    <ListGroupItem
                      id={`${question.questionCode}_choice_${index}`}
                      key={`${question.questionCode}${choice.answerChoice}`}
                      active={getAnswerForQuestion(question.questionCode)?.answerChoice === choice.answerChoice}
                      onClick={() =>
                        handleSelectAnswer(
                          question.questionCode,
                          question.answerMode,
                          choice.answerChoice,
                          choice.optionalCode
                        )
                      }
                      style={{ flexBasis: 'calc(50% - 1px)' }}
                    >
                      <span>{choice.textTH}</span>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </li>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Suitability
